define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/heading/ActionData",
	"csi/heading/Boolean",
	"csi/sessionConstants",
	"csi/state/rootStore",
	"csi/xml"
], function(array,declare,lang,csi,ActionData,BooleanRen,sessionConstants,{ sessionStore },xml) {

	return declare(BooleanRen, {
		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: disable filtering
			return null;
		},

		_getRenderAction: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h) {
			// make sure node is not the current user
			const url = ctx.getNodeURL();
			const currentUserURL = sessionConstants.userUrl;
			const currentUser = sessionStore.currentUser;

			if(url == currentUserURL && xml.isValidURL(currentUser.__Parent__))
				return null;
			
			if (!xml.nodeHasRight(ctx.getNode(), xml.RIGHT_WRITE))
				return null;
			
			return lang.mixin(new ActionData(), {
				action: h.m_action,
				heading: h,
				ren: this
			});
		},
		
		_getValue: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h) {
			// summary: determine if Online User has Team Manager role assignment
			// 			iterate through CrewAssignments to check if user exists 
			var crewAssignments = ctx.cache.getPathNodes(ctx.getNode(), "Child:__Parent__/Child:Assignments");
			
			var	a = csi.search(crewAssignments, function(a) {
				return ctx.cache.getNode(a.Role).$Name == "Team Manager"; 
			});
			
			return !!a && (array.indexOf(a.AssignedUsers, ctx.getNodeURL()) >= 0);
		}
	});
});